// extracted by mini-css-extract-plugin
module.exports = {"container":"SideBar_container__3eSoE","positionRight":"SideBar_positionRight__3yOue","wide":"SideBar_wide__NxRaz"};